var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
__export(exports, {
  Chain: () => import_chain2.default,
  Chains: () => import_chains2.default,
  default: () => src_default
});
var import_chains = __toModule(require("./chains"));
var import_chain2 = __toModule(require("./chain"));
var import_chains2 = __toModule(require("./chains"));
const instance = () => {
  const chains = new import_chains.default();
  return {
    chains: () => __async(void 0, null, function* () {
      return yield chains.all();
    }),
    chain: (id) => __async(void 0, null, function* () {
      return yield chains.chainById(id);
    }),
    chainField: (id, field) => __async(void 0, null, function* () {
      return yield chains.chainFieldById(id, field);
    })
  };
};
const Instance = instance();
var src_default = Instance;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Chain,
  Chains
});
